(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["faceted-filters"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', (event) => {
    const input = event.target;
    if (!input.matches('#CollectionFilterForm input[name="filter.v.option.size"], #CollectionFilterForm input[name="filter.v.option.sizes"]') || !input.checked) return;
    const availability = input.form?.querySelector('input[name="filter.v.availability"][value="1"]');
    if (availability) availability.checked = true;
  }, true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["magpie-collection-carousel"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',function(event){
  const button=event.target.closest('[data-carousel-direction]');
  if(!button)return;
  const track=document.getElementById(button.getAttribute('aria-controls'));
  if(!track)return;
  const card=track.querySelector('.mcc__card');
  if(!card)return;
  const step=card.getBoundingClientRect().width+parseFloat(getComputedStyle(track).columnGap);
  const count=Math.max(1,Math.floor(track.clientWidth/step));
  track.scrollBy({left:Number(button.dataset.carouselDirection)*step*count,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["magpie-landing-products"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',function(event){
  const button=event.target.closest('[data-weekly-direction]');
  if(!button)return;
  const track=button.closest('.magpie-landing-products').querySelector('#MagpieWeeklyProducts');
  track.scrollBy({left:Number(button.dataset.weeklyDirection)*track.clientWidth*.85,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["magpie-navigation"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',function(event){const summary=event.target.closest('.magpie-nav--structured > li > details > summary');if(!summary)return;const current=summary.parentElement;const nav=current.closest('.magpie-nav--structured');nav.querySelectorAll(':scope > li > details[open]').forEach(item=>{if(item!==current)item.open=false;});});

document.addEventListener('keydown',function(event){if(event.key!=='Escape')return;const nav=event.target.closest('.magpie-nav--structured');if(!nav)return;const details=event.target.closest('details[open]');if(details){details.open=false;details.querySelector('summary').focus();event.stopPropagation();}});
  } catch(e) { console.error(e); }
})();

})();
